<div #snapshotTitleBar class="snapshot-title-bar">
  <span class="snapshot-left-info-container">
    <span class="snapshot-title-container" [hidden]="hideSnapshotTitle()">
      <span class="snapshot-title" *ngIf="isLicenceActive">{{ 'snapshot_Device_Snapshot_title' | xsI18n }}</span>
      <span class="snapshot-title" *ngIf="!isLicenceActive">{{ 'ticket_RemoteControlTabs_DeviceInfo' | xsI18n }}</span>
      <span class="separator"></span>
    </span>
    <span id="device-icon" class="device-icon-container" *ngIf="getDeviceFamily()">
      <span [ngClass]="getDeviceIconClass()"></span>
      <span [ngClass]="getDeviceScreenIconClass()"></span>
    </span>
    <span class="link-container">
      <a class="device-link" *ngIf="getDeviceURL()" [href]="getDeviceURL()" target="_blank" rel="noopener">
        <span class="device-title" sa-ellipsis [fullText]="getDeviceName()" placement="bottom"></span>
      </a>
      <span
        class="device-title"
        *ngIf="!getDeviceURL()"
        sa-ellipsis
        class="device-name-container"
        placement="bottom"
        [fullText]="getDeviceName()"
      ></span>
    </span>
  </span>
  <span class="snapshot-right-info-container">
    <span class="date-and-mc-container">
      <span sa-ellipsis *ngIf="!isLiveSnapshot" class="mc-name" placement="bottom" [fullText]="mcName"></span>
      <span class="snapshot-date" *ngIf="!isLiveSnapshot && isLicenceActive">{{ getDate() }}</span>
      <span class="snapshot-date" *ngIf="isLiveSnapshot"
        ><xs-updating-time [hidespan]="true" [time]="date"></xs-updating-time
      ></span>
    </span>
    <span class="buttons-container">
      <span class="snapshot-title-bar-button" *ngIf="isMinimizeButtonVisible">
        <div class="hd-icon hd-icon-minimize icon-sm snapshot-title-bar-button-icon" (click)="minimizeSnapshot()"></div>
      </span>
      <span
        class="snapshot-title-bar-button"
        *ngIf="isPopOutVisible()"
        [soti-tooltip]="getPopoutToolTip()"
        placement="left"
        [attr.disabled]="!isPopOutEnabled() || isSnapshotRefreshInProgress || snapshotRecording() ? '' : null"
      >
        <div class="hd-icon hd-icon-popout icon-md snapshot-title-bar-button-icon" (click)="popOutSnapshot()"></div>
      </span>
      <span
        class="snapshot-title-bar-button"
        *ngIf="isPopInVisible()"
        [soti-tooltip]="getPopinToolTip()"
        placement="left"
        [attr.disabled]="!isPopInEnabled() || isSnapshotRefreshInProgress ? '' : null"
      >
        <div class="hd-icon hd-icon-popin icon-md snapshot-title-bar-button-icon" (click)="popInSnapshot()"></div>
      </span>
      <span class="snapshot-title-bar-button" *ngIf="isCloseVisible()">
        <div class="hd-icon hd-icon-close icon-md snapshot-title-bar-button-icon" (click)="closeSnapshot()"></div>
      </span>
    </span>
  </span>
</div>
